"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXLaw = exports.HTMLLaw = exports.HTMLLawCSS = exports.DOCXPreamble = exports.HTMLPreamble = exports.HTMLPreambleCSS = exports.DOCXEnactStatement = exports.HTMLEnactStatement = exports.HTMLEnactStatementCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const articleGroup_1 = require("./articleGroup");
const _sentenceChildren_1 = require("../../parser/cst/rules/$sentenceChildren");
const appdxItem_1 = require("./appdxItem");
const paragraphItem_1 = require("./paragraphItem");
const toc_1 = require("./toc");
const EmptyParagraph_1 = __importDefault(require("../common/docx/EmptyParagraph"));
const common_1 = require("../common");
exports.HTMLEnactStatementCSS = `
.enact-statement {
    clear: both;
}
`;
exports.HTMLEnactStatement = (0, html_1.wrapHTMLComponent)("HTMLEnactStatement", ((props) => {
    const { el, htmlOptions, indent } = props;
    return (react_1.default.createElement("div", { className: `enact-statement indent-${indent}`, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
}));
exports.DOCXEnactStatement = (0, component_1.wrapDOCXComponent)("DOCXEnactStatement", ((props) => {
    const { el, docxOptions, indent } = props;
    return (react_1.default.createElement(tags_1.w.p, null,
        react_1.default.createElement(tags_1.w.pPr, null,
            react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
        react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: el.children, docxOptions })));
}));
exports.HTMLPreambleCSS = `
.preamble {
    clear: both;
}
`;
exports.HTMLPreamble = (0, html_1.wrapHTMLComponent)("HTMLPreamble", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    for (const child of el.children) {
        if (std.isParagraph(child)) {
            blocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement("div", { className: "preamble", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXPreamble = (0, component_1.wrapDOCXComponent)("DOCXPreamble", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    for (const child of el.children) {
        if (std.isParagraph(child)) {
            blocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
exports.HTMLLawCSS = `
.law-title {
    font-weight: bold;
}

.law-num {
    font-weight: bold;
}
`;
exports.HTMLLaw = (0, html_1.wrapHTMLComponent)("HTMLLaw", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const LawTitle = el.children.find(std.isLawBody)?.children.find(std.isLawTitle);
    const LawNum = el.children.find(std.isLawNum);
    if (LawTitle) {
        blocks.push((react_1.default.createElement("div", { className: `law-title indent-${indent}`, ...(0, html_1.elProps)(LawTitle, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: LawTitle.children, htmlOptions }))));
    }
    if (LawNum) {
        const LawNumString = (0, _sentenceChildren_1.sentenceChildrenToString)(LawNum.children);
        const LawNumChildren = [...LawNum.children];
        if (!/^[(（]/.test(LawNumString))
            LawNumChildren.unshift("（");
        if (!/[)）]$/.test(LawNumString))
            LawNumChildren.push("）");
        blocks.push((react_1.default.createElement("div", { className: `law-num indent-${indent}`, ...(0, html_1.elProps)(LawNum, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: LawNumChildren, htmlOptions }))));
    }
    const bodyBlocks = [];
    for (const child of el.children.find(std.isLawBody)?.children ?? []) {
        if (std.isLawTitle(child)) {
            continue;
        }
        else if (std.isTOC(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(toc_1.HTMLTOC, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isMainProvision(child) || std.isSupplProvision(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(articleGroup_1.HTMLArticleGroup, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isAppdxItem(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(appdxItem_1.HTMLAppdxItem, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isEnactStatement(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(exports.HTMLEnactStatement, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isPreamble(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(exports.HTMLPreamble, { el: child, indent: indent, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement("div", { className: "empty" },
                react_1.default.createElement("br", null)));
        blocks.push((react_1.default.createElement("div", { className: "law-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "law", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXLaw = (0, component_1.wrapDOCXComponent)("DOCXLaw", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const LawTitle = el.children.find(std.isLawBody)?.children.find(std.isLawTitle);
    const LawNum = el.children.find(std.isLawNum);
    if (LawTitle) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: LawTitle.children, emphasis: true, docxOptions }))));
    }
    if (LawNum) {
        const LawNumString = (0, _sentenceChildren_1.sentenceChildrenToString)(LawNum.children);
        const LawNumChildren = [...LawNum.children];
        if (!/^[(（]/.test(LawNumString))
            LawNumChildren.unshift("（");
        if (!/[)）]$/.test(LawNumString))
            LawNumChildren.push("）");
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: LawNumChildren, emphasis: true, docxOptions }))));
    }
    for (const child of el.children.find(std.isLawBody)?.children ?? []) {
        if (std.isLawTitle(child)) {
            continue;
        }
        else if (std.isTOC(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(toc_1.DOCXTOC, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isMainProvision(child) || std.isSupplProvision(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(articleGroup_1.DOCXArticleGroup, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isAppdxItem(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(appdxItem_1.DOCXAppdxItem, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isEnactStatement(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(exports.DOCXEnactStatement, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isPreamble(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(exports.DOCXPreamble, { el: child, indent: indent, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=law.js.map